import {Suspense, lazy} from 'react';
import {useUIVariant} from 'hooks/useUIVariant';
import {UI_VARIANTS} from 'utils/uiVariant';
import {SplashScreen} from 'components/SplashScreen';

const LegacySplashScreen = lazy(() => import('@legacy/components/SplashScreen'));

function SplashSwitch() {
  const {variant, isResolved} = useUIVariant();

  if (!isResolved || variant === UI_VARIANTS.redesign) {
    return <SplashScreen />;
  }

  return (
    <Suspense fallback={<SplashScreen />}>
      <LegacySplashScreen />
    </Suspense>
  );
}

export default SplashSwitch;
